"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCouriersQuery = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _fetching = require("@ori/fetching");
var _react = require("react");
var _swrConfig = require("../constants/swrConfig");
var _contexts = require("../contexts");
var _useUrlOptions = require("../hooks/useUrlOptions");
var _logger = require("../logger");
var _utils = require("../utils");
const fetchData = async options => {
  const promise = (0, _utils.getUrl)(options);
  promise.catch(error => {
    _logger.mainLogger.error(error, {
      action: 'useCouriersQuery'
    });
  });
  return promise;
};
const useCouriersQuery = ({
  activeCourier,
  addressId,
  setActiveCourier,
  setIsDeliveryChanged,
  shouldCheckValidCourier = true
}) => {
  const {
    customerId = _auth.NOT_LOGGED_IN_USER_ID,
    isSubscriptionsPage
  } = (0, _contexts.useCheckoutDeliveryContext)();
  // areCouriersInitiated - Avoid mutate of query before initiation from CourierSelection component
  const [areCouriersInitiated, setAreCouriersInitiated] = (0, _react.useState)(false);
  const usedParams = {
    customerId,
    addressId
  };
  const {
    cacheKeys,
    urlOptions
  } = (0, _useUrlOptions.useUrlOptions)('/system/ajax/DeliverySelection/GetCouriers', usedParams);
  const swrOptions = {
    ..._swrConfig.errorHandlingSwrOptions,
    onSuccess: data => {
      (0, _logger.logInfo)('useCouriersQuery() hook finished successfully', data);
      if (!areCouriersInitiated) {
        setAreCouriersInitiated(true);
      }
      if (!shouldCheckValidCourier) {
        return;
      }
      const selectFirstCourier = async () => {
        const isSelectedCourierValid = data.some(courier => courier.deliveryChannelId === activeCourier);
        if (isSelectedCourierValid || !data[0] || !setActiveCourier || !setIsDeliveryChanged) {
          return;
        }
        const {
          deliveryChannelId
        } = data[0];
        (0, _logger.logDebug)(`Selecting first courier from the list (${deliveryChannelId}) as the previously selected courier (${activeCourier}) was not found.`);
        setActiveCourier(deliveryChannelId);
        if (!isSubscriptionsPage) {
          try {
            await (0, _utils.changeActiveDelivery)({
              addressId,
              deliveryChannelId
            });
          } catch (error) {
            (0, _checkoutUtils.showErrorNotification)();
            const helpMessage = `Error while changing active delivery item after couriers query. AddressId: ${addressId}, deliveryChannelId: ${deliveryChannelId}`;
            _logger.mainLogger.error(error, {
              action: 'selectFirstCourier',
              message: helpMessage
            });
            // TODO: what about the new courier selection in this case, return to previous value or reset to 0?
          }
          setIsDeliveryChanged(true);
        }
      };
      void selectFirstCourier();
    }
  };
  const fetcher = async () => fetchData(urlOptions);
  const {
    data: couriers,
    error: couriersError,
    isValidating: isCouriersLoading,
    mutate: mutateCouriers
  } = (0, _fetching.useSWR)(addressId === undefined ? null : cacheKeys, fetcher, swrOptions);
  return {
    areCouriersInitiated,
    couriers,
    couriersError,
    isCouriersLoading,
    mutateCouriers
  };
};
exports.useCouriersQuery = useCouriersQuery;